import {createApp} from 'vue'
import options from './VideoBlock.options'

const el = '.nyk-component--video-block'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    DOM.forEach((VideoBlockDOM)=>{
        const template = VideoBlockDOM.outerHTML
        options.template = template

        const component = createApp(options).use(Store)
        component.mount(VideoBlockDOM)
    })
}
